import * as Yup from "yup";

export function initialValues(student) {
  return {
    avatar: student?.User?.avatar || "",
    fileAvatar: null,
    firstname: student?.User?.firstname || "",
    lastname: student?.User?.lastname || "",
    secondLastname: student?.User?.secondLastname || "",
    email: student?.User?.email || "",
    dni: student?.User?.dni || "",
    phone: student?.User?.phone || "",
    phone2: student?.User?.phone2 || "",
    birthDate: student?.User?.birthDate || "",
    departament: student?.User?.departament || "",
    province: student?.User?.province || "",
    district: student?.User?.district || "",
    address: student?.User?.address || "",
    dni_tutor: student?.User?.dni_tutor || "",
    name_tutor: student?.User?.name_tutor || "",
    familyRelationship: student?.User?.familyRelationship || null,
    gradeId: student?.gradeId || "",
    paymentCategoryId: student?.paymentCategoryId || "",
    userId: student?.userId || "",
  };
}

export function validationSchema() {
  return Yup.object({
    firstname: Yup.string().required("El nombre es obligatorio"),
    lastname: Yup.string().required("El apellido paterno es obligatorio"),
    secondLastname: Yup.string().required("El apellido materno es obligatorio"),
    email: Yup.string()
      .email("El correo no es válido")
      .required("El correo es obligatorio"),
    dni: Yup.number()
      .typeError("El DNI debe ser numérico")
      .required("El DNI es obligatorio"),
    phone: Yup.number()
      .typeError("El teléfono debe ser numérico")
      .required("El teléfono es obligatorio"),
    phone2: Yup.number().typeError("El teléfono debe ser numérico").nullable(),
    birthDate: Yup.string().required("La fecha de nacimiento es obligatoria"),
    departament: Yup.string().required("El departamento es obligatorio"),
    district: Yup.string().required("El distrito es obligatorio"),
    province: Yup.string().required("La provincia es obligatoria"),
    address: Yup.string().required("La dirección es obligatoria"),
    name_tutor: Yup.string().required("El nombre del tutor es obligatorio"),
    familyRelationship: Yup.string()
      .nullable()
      .required("La relación familiar con el tutor es obligatoria"),
    gradeId: Yup.string().required("El grado es obligatorio"),
    paymentCategoryId: Yup.string().required(
      "La categoría de pago es obligatoria"
    ),
    userId: Yup.string().required("El usuario es obligatorio"),
  });
}
